// extracted by mini-css-extract-plugin
export default {"svcFlex":"svcFlex___imcrO","svcImage":"svcImage___Mwp0X","fallbackImage":"fallbackImage___KcMIG"};